import { render, staticRenderFns } from "./ProductsCRUD.vue?vue&type=template&id=3faa6987&"
import script from "./ProductsCRUD.vue?vue&type=script&lang=js&"
export * from "./ProductsCRUD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports